import { Autocomplete, Button, Stack, TextField } from '@mui/material'
import * as React from 'react'
import { Search } from '@mui/icons-material'
import { tsGetLimsOrdersFilters } from './OrdersList'
import { autoOptionsFromCodeValues, autoOptionsFromData } from '../../../Functions/ListItemGenerator'
import { useBioBankContext } from '../../../Contexts/Modules/BioBankModule'
import { stackGap } from '../../../Constants&Theme/Spacing'
import { DesktopDateRangePicker } from '@mui/lab'

function OrdersAsyncToolbar({
  apiFilters,
  setApiFilters,
}: {
  apiFilters: tsGetLimsOrdersFilters
  setApiFilters: any
}) {
  const { ownersQuery, statusQuery } = useBioBankContext()
  return (
    <Stack
      direction={'row'}
      gap={stackGap.row}
      width={1}
      mb={2}
    >
      <Autocomplete
        value={
          ownersQuery.data && ownersQuery.data.length === 1 ?
            {
              value: ownersQuery.data[0].OwnerID,
              label: ownersQuery.data[0].OwnerName,
            }
          : null
        }
        isOptionEqualToValue={(option, value) => {
          return option.value === value.value
        }}
        onChange={(event: any, newValue: any) => {
          setApiFilters((f: any) => {
            return { ...f, owner_id: newValue?.value ?? null, enabled: false }
          })
        }}
        renderInput={(params) => (
          <TextField
            label={'Owner'}
            {...params}
          />
        )}
        loading={ownersQuery.isLoading}
        fullWidth
        options={autoOptionsFromData(
          ownersQuery.data,
          'OwnerID',
          'OwnerName',
        ).sort((a: any, b: any) => {
          return a.label.localeCompare(b.label)
        })}
      />
      <Autocomplete
        isOptionEqualToValue={(option, value) => {
          return option.value === value.value
        }}
        onChange={(event: any, newValue: any) => {
          setApiFilters((f: any) => {
            return { ...f, status: newValue?.value ?? null, enabled: false }
          })
        }}
        renderInput={(params) => (
          <TextField
            label={'Status'}
            {...params}
          />
        )}
        loading={ownersQuery.isLoading}
        fullWidth
        options={autoOptionsFromCodeValues(statusQuery.data)}
      />
      <DesktopDateRangePicker
        sx={{ minWidth: 280 }}
        value={[apiFilters.start_range, apiFilters.end_range] ?? undefined}
        onChange={(newValue: any) =>
          setApiFilters((f: any) => {
            return {
              ...f,
              enabled: false,
              start_range: newValue?.[0],
              end_range: newValue?.[1],
            }
          })
        }
      />
      <Button
        sx={{ minWidth: 120 }}
        startIcon={<Search />}
        variant={'contained'}
        disabled={
          apiFilters?.enabled ||
          !(!!apiFilters?.start_range && !!apiFilters?.end_range)
        }
        onClick={() => {
          setApiFilters((f: any) => {
            return { ...f, enabled: true }
          })
        }}
      >
        Search
      </Button>
    </Stack>
  )
}

export default OrdersAsyncToolbar
